module.exports = __webpack_public_path__ + "images/emoji/blush.4977dd20a8c692de5b6f.png";